import { useEffect, useState } from 'react';

export enum DEVICE {
  DESKTOP,
  TABLET,
  MOBILE,
}

const deviceRule = (width: number) => {
  if (width >= 940) {
    return DEVICE.DESKTOP;
  } else if (width >= 769) {
    return DEVICE.TABLET;
  } else {
    return DEVICE.MOBILE;
  }
};

export const useDevice = () => {
  const [device, setDevice] = useState<DEVICE>(DEVICE.DESKTOP);
  useEffect(() => {
    const handleWindowResize = (event: Event) => {
      const window = event.target as Window;
      setDevice(deviceRule(window.innerWidth));
    };
    setDevice(deviceRule(window.innerWidth));
    window.addEventListener('resize', handleWindowResize);

    return () => {
      window.removeEventListener('resize', handleWindowResize);
    };
  }, []);
  return { device };
};
